export default "\n    <router-outlet #outlet=\"outlet\" ></router-outlet>\n\n\n\n";